/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import React, { useEffect, useState } from "react";
// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React context
import { useMaterialUIController } from "context";
import apiClient from "./../../../../../apiClient";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

function AddCity({ onClose, onSuccess, onFailed, editFormData }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const [state, setState] = useState([]);
  const [district, setDistrict] = useState([]);
  const [editData, setEditData] = useState(editFormData);

  useEffect(() => {
    getState();
    if (editData.stateId) {
      getDistrict(editData.stateId);
    }
  }, []);

  const getState = async () => {
    const response = await apiClient.get("/admin/state");
    if (response.status === 200) {
      setState(response.data);
    }
  };

  const getDistrict = async (state) => {
    const response = await apiClient.get(`/admin/district/state/${state}`);
    if (response.status === 200) {
      setDistrict(response.data);
    }
  };

  const [formData, setFormData] = useState({
    state: editData.state || "",
    stateId: editData.stateId || "",
    district: editData.district || "",
    districtId: editData.districtId || "",
    name: editData.name || "",
    status: editData.status || "Active",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "state") {
      console.log("State:", value);
      let stateID = state.find((item) => item.name === value)._id;
      getDistrict(stateID);
    }
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Handle form submission logic here
    const isEdit = editData && Object.keys(editData).length > 0; // Check if editData exists
    try {
      let payload = {
        state: formData.state,
        district: formData.district,
        name: formData.name,
        status: formData.status,
        districtId: district.find((item) => item.name === formData.district)._id || "",
        stateId: state.find((item) => item.name === formData.state)._id || "",
      };

      const endpoint = isEdit ? `/admin/cites/update/${editData._id}` : "/admin/cites"; // Use ID for PUT
      const method = isEdit ? apiClient.put : apiClient.post; // PUT for edit, POST for create

      // Make the API request
      const response = await method(endpoint, payload);
      if (response.status === 200) {
        if (response.data.status === "success") {
          onSuccess();
          onClose();
        } else if (response.data.status === "false") {
          console.error("Error creating city:", response.data.message);
          // showing failed message in snackbar
          onFailed(response.data.message);
          onClose();
        }
      }
    } catch (error) {
      console.error("Error creating city:", error);
    }
  };

  return (
    <Card id="add-city">
      <MDBox p={4}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} lg={12}>
            <Grid item xs={12}>
              <FormControl fullWidth size="medium" sx={{ mt: 0 }}>
                <InputLabel id="state-label">State</InputLabel>
                <Select
                  label="state"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  required
                  IconComponent={(props) => <ArrowDropDownIcon {...props} />}
                  sx={{
                    height: "46px",
                    display: "flex",
                    alignItems: "center",
                    "& .MuiSelect-icon": {
                      color: darkMode ? "#fff" : "#000",
                      display: "block",
                    },
                  }}
                >
                  <MenuItem value="">
                    <em>Select State</em>
                  </MenuItem>
                  {state &&
                    state.length > 0 &&
                    state.map((item) => (
                      <MenuItem key={item._id} value={item.name}>
                        {item.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth size="medium" sx={{ mt: 0 }}>
                <InputLabel id="state-label">District</InputLabel>
                <Select
                  label="District"
                  name="district"
                  value={formData.district}
                  onChange={handleChange}
                  required
                  sx={{
                    height: "46px",
                    display: "flex",
                    alignItems: "center",
                    "& .MuiSelect-icon": {
                      color: darkMode ? "#fff" : "#000",
                      display: "block",
                    },
                  }}
                >
                  <MenuItem value="">
                    <em>Select District</em>
                  </MenuItem>
                  {district &&
                    district.length > 0 &&
                    district.map((item) => (
                      <MenuItem key={item._id} value={item.name}>
                        {item.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ color: "#fff" }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </MDBox>
    </Card>
  );
}

export default AddCity;
